module.exports = __webpack_public_path__ + "img/solid-heart-minus-dark.a5fbfd28.svg";